import React from "react";
import {
  FormControl,
  Select,
  MenuItem,
  OutlinedInput,
  ListItemText,
} from "@mui/material";
import "../components.scss";
import { CustomCheckbox } from "../../../../../common/components";

interface RoleSelectProps {
  value: number | number[] | string;
  onChange: (value: number | number[]) => void;
  roles: { label: string; value: number | string }[];
  touched?: boolean;
  error?: any;
  isLabelled?: boolean;
  isRequired?: boolean;
  isMultiple?: boolean;
}

const RoleSelect: React.FC<RoleSelectProps> = ({
  value,
  onChange,
  roles,
  touched,
  error,
  isLabelled,
  isRequired,
  isMultiple = false,
}) => {

  const renderSelectedValues = (selected: any) => {
    if (!selected || (Array.isArray(selected) && selected.length === 0)) {
      return <div className="default-label">Select a role</div>;
    }
    if (isMultiple && Array.isArray(selected)) {
      return roles
        .filter((r) => selected.includes(Number(r.value)))
        .map((r) => r.label)
        .join(", ");
    }
    const selectedRole = roles.find(
      (role) => String(role.value) === String(selected)
    );
    return selectedRole ? selectedRole.label : <em>Unknown role</em>;
  };

  return (
    <FormControl
      fullWidth
      error={touched && !!error}
      className="user-requests-select"
    >
      {isLabelled && (
        <label htmlFor="role-select" className="form-label">
          Role{isRequired && <span className="required-asterisk">*</span>}
        </label>
      )}
      <Select
        id="role-select"
        multiple={isMultiple}
        className="custom-role-select"
        value={value}
        onChange={(event) => {
          const selectedValue = event.target.value;
          if (isMultiple) {
            onChange(selectedValue as number[]);
          } else {
            onChange(Number(selectedValue));
          }
        }}
        displayEmpty
        input={<OutlinedInput />}
        renderValue={renderSelectedValues}
        inputProps={{ "aria-label": "Role select" }}
      >
        {!isMultiple && (
          <MenuItem disabled value="">
            <em>Select a role</em>
          </MenuItem>
        )}
        {roles.map((role) => (
          <MenuItem
            key={role.value}
            value={Number(role.value)}
          >
            <ListItemText primary={role.label} />
          </MenuItem>
        ))}
      </Select>
      {touched && error && <div className="error-message">{error}</div>}
    </FormControl>
  );
};

export default RoleSelect;